<div class="product-wrapper" [routerLink]="category.path" [queryParams]="{'category': category.parameter}" >
    <div class="product-image" [style.background-image]="'url(' + (category.image ) + ')'" >
        </div>
        <div>
            <h5 class="text-center uppercase-text" style="color: white;">{{category.title | titlecase}}</h5>
        </div>
        <div class="cta text-center ">
            SHOP NOW
        </div>
</div>